import axios from 'axios';
import ReactPaginate from 'react-paginate'
import $ from 'jquery';
import React, { Component, useState } from 'react'
import Cookies from 'universal-cookie';
import "../../services/ApiRest";
import swal from 'sweetalert';
import { ApiUrl } from '../../services/ApiRest';
import { Table, Button, Container, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, ListGroupItemText, Alert } from 'reactstrap';

const urlListarCarrAsigTipoTitu = ApiUrl + "carrerasasigtipoTitu" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlIngresarTipoTitulacion = ApiUrl + "ingresartipotitul" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlDatosTipoTitulacion = ApiUrl + "datostipotitul" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlModificarTipoTitulacion = ApiUrl + "modificartipotitul" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarCarreras = ApiUrl + "listarcarreras" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlCambiarEstTipoTitulacion = ApiUrl + "actdesactestadotipotitul" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarTiposTitulacionxCarroTodos = ApiUrl + "listartipotitulcarrotodos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
let listaauxiliar = [];
const itemsPerPage = 10;
export default class ListTiposTitulacion extends Component {

    constructor(props) {
        super(props)
        this.state = {
            listCarrTipoTitulMod: [],
            carrera: [],
            //variables para paginacion
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            count: 0,
        }
        this.handleChange = this.handleChange.bind(this);
        this.escFunction = this.escFunction.bind(this);
    }
    escFunction(event) {
        if (event.key === "Escape") {
            this.setState({ modalIngresarTipoTitulacion: false });
            this.setState({ modalModTipoTitulacion: false });
            this.setState({ modalRegistroDocumento: false });
            this.setState({ modalModificarDocumento: false });
        }
    }
    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ estado: "" });

    }

    componentDidMount() {
        document.addEventListener("keydown", this.escFunction, true);
        //Listar las carreras
        axios.get(urlListarCarreras)
            .then(res => {
                const carrera = res.data;
                this.setState({ carrera });
            })

    }

    handleChangeCarrera = async (e) => {
        const idCarrera = e.target.value;
        this.setState({ [e.target.name]: idCarrera });
        try {
            const { data } = await axios.get(urlListarTiposTitulacionxCarroTodos, {
                params: { idCarrera }
            });

            if (data.success) {
                const lista = data.data;
                const itemOffset = 0;
                const endOffset = itemOffset + itemsPerPage;

                this.setState({
                    estud: lista,
                    EstudianteBackup: lista,
                    currentItems: lista.slice(itemOffset, endOffset),
                    pageCount: Math.ceil(lista.length / itemsPerPage),
                    itemOffset
                });
            } else {
                this.setState({ currentItems: [], error: "No existe información" });
                swal({
                    text: "¡No existen tipos de titulación registrados!",
                    icon: "info",
                    button: "Aceptar",
                });
            }
        } catch (error) {
            console.error(error);
            swal({
                text: "Error al cargar los tipos de titulación.",
                icon: "error",
                button: "Aceptar",
            });
        }
    };

    //BUSQUEDA......
    filter(event) {
        console.log(event.target.value);
        //obtener datos de buscar
        var text = event.target.value
        //obtener datos del array
        const data = this.state.estud
        var newData = data.filter(function (item) {
            //variable del objeto
            const itemDataNom = item.nom_tipo_titulacion.toUpperCase();
            const itemDataDescrip = item.descrip_tipo_titulacion.toUpperCase();
            const campo = itemDataNom + " " + itemDataDescrip;
            //variable del buscador
            const textData = text.toUpperCase()
            //return itemData.indexOf(textData)> -1
            return campo.indexOf(textData) > -1

        })

        if (text == "") {
            newData = this.state.EstudianteBackup;
        }
        this.setState({
            currentItems: newData,
            textBuscar: text,
        })

    }
    //FUNCION DE PAGINACION POR  MEDIO DE UN CLIC
    handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
        const endOffset = newOffset + itemsPerPage;
        this.setState({ currentItems: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ EstudianteBackup: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
    }

    //Modal de Ingreso
    mostrarModalIngresoTiposTitulacion = (registro) => {
        this.setState({ modalIngresarTipoTitulacion: true });
    }
    //Ocultar modal de ingreso
    ocultarModalIngresarTipoTitul = () => {
        this.setState({ modalIngresarTipoTitulacion: false });
    }
    //ingresar
    ingresarDatosTipoTitulacion = async () => {
        try {
            // Crear la lista de carreras seleccionadas
            const carreraselect = $("input:checkbox.checkbox-carrtipotituing:checked")
                .map(function () {
                    return { idCarr: $(this).closest("tr").find("td").eq(0).text() };
                })
                .get();

            const gsoncarrerasselect = JSON.stringify(carreraselect);

            // 1) Insertar datos
            const response = await axios.post(urlIngresarTipoTitulacion, {
                nombrett: this.state.nombretipo,
                descripciontt: this.state.descriptipo,
                estadott: 1,
                listcarreras: gsoncarrerasselect,
            });

            if (response.data.success) {
                swal({
                    text: "Datos procesados correctamente",
                    icon: "success",
                    button: "Aceptar",
                });

                // 2) Refrescar listado
                const { data } = await axios.get(urlListarTiposTitulacionxCarroTodos, {
                    params: { idCarrera: this.state.idCarrera }
                });

                if (data.success) {
                    const lista = data.data;
                    const itemOffset = 0;
                    const endOffset = itemOffset + itemsPerPage;

                    this.setState({
                        estud: lista,
                        EstudianteBackup: lista,
                        currentItems: lista.slice(itemOffset, endOffset),
                        pageCount: Math.ceil(lista.length / itemsPerPage),
                        itemOffset,
                        modalIngresarTipoTitulacion: false
                    });
                } else {
                    this.setState({
                        currentItems: [],
                        error: "No existe información",
                        modalIngresarTipoTitulacion: false
                    });
                    swal({
                        text: "¡No existen tipos de titulación registrados!",
                        icon: "info",
                        button: "Aceptar",
                    });
                }
            } else {
                swal({
                    text: "Datos no actualizados",
                    icon: "error",
                    button: "Aceptar",
                });
                this.setState({ modalIngresarTipoTitulacion: false });
            }
        } catch (error) {
            console.error(error);
            this.setState({ error: "No existe conexión con el servidor", modalIngresarTipoTitulacion: false });
            swal({
                text: "No existe conexión con el servidor",
                icon: "error",
                button: "Aceptar",
            });
        }
    };


    //Mostar el modal de modificar datos de un tipo de titulación
    mostrarModalDatosTipoTitulacion = (dato) => {
        //Datos de un tipo de titulación
        axios.post(urlDatosTipoTitulacion, {
            idTipoTitulacion: dato.id_tipo_titulacion,
        })
            .then(response => {
                const TipoTitulacion = response.data.data;
                $(function () {
                    $("#nombretipomod").val(TipoTitulacion[0].nom_tipo_titulacion);
                    $("#descriptipomod").val(TipoTitulacion[0].descrip_tipo_titulacion);
                    $("#idestadomod").val(TipoTitulacion[0].estado_tipo_titulacion);
                });


                this.setState({ idtipomod: dato.id_tipo_titulacion });
                this.setState({ nombretipomod: TipoTitulacion[0].nom_tipo_titulacion });
                this.setState({ descriptipomod: TipoTitulacion[0].descrip_tipo_titulacion });
                this.setState({ idestadomod: TipoTitulacion[0].estado_tipo_titulacion });
                //Lista las carreras asignadas a un tipo de titulación
                axios.post(urlListarCarrAsigTipoTitu, {
                    idTipoTitu: dato.id_tipo_titulacion
                })
                    .then(response => {
                        const listaCarrTitulacionMod = response.data.data;
                        this.setState({ listCarrTipoTitulMod: listaCarrTitulacionMod });
                    })
            })
        this.setState({ modalModTipoTitulacion: true });
    }
    //Ocultar el modal de modificar los datos de un tipo de titulación
    ocultarModalModificartDatosTipoTitulacion = () => {
        this.setState({ modalModTipoTitulacion: false });
    }
    //modificar
    modificarDatosTipoTitulacion = async () => {
        try {
            // Crear la lista de roles seleccionados
            const carreraselect = $("input:checkbox.checkbox-carrtipotitumod:checked")
                .map(function () {
                    return { idCarrMod: $(this).closest("tr").find("td").eq(0).text() };
                })
                .get();

            const gsoncarrerasselect = JSON.stringify(carreraselect);

            // 1) Enviar actualización
            const response = await axios.post(urlModificarTipoTitulacion, {
                idttmod: this.state.idtipomod,
                nombrettmod: this.state.nombretipomod,
                descripcionttmod: this.state.descriptipomod,
                estadomod: this.state.idestadomod,
                listcarrerasmod: gsoncarrerasselect,
            });

            if (response.data.success) {
                swal({
                    text: "Datos procesados correctamente",
                    icon: "success",
                    button: "Aceptar",
                });

                // 2) Refrescar listado
                const { data } = await axios.get(urlListarTiposTitulacionxCarroTodos, {
                    params: { idCarrera: this.state.idCarrera }
                });

                if (data.success) {
                    const lista = data.data;
                    const itemOffset = 0;
                    const endOffset = itemOffset + itemsPerPage;

                    this.setState({
                        estud: lista,
                        EstudianteBackup: lista,
                        currentItems: lista.slice(itemOffset, endOffset),
                        pageCount: Math.ceil(lista.length / itemsPerPage),
                        itemOffset,
                        modalModTipoTitulacion: false
                    });
                } else {
                    this.setState({ currentItems: [], error: "No existe información", modalModTipoTitulacion: false });
                    swal({
                        text: "¡No existen tipos de titulación registrados!",
                        icon: "info",
                        button: "Aceptar",
                    });
                }
            } else {
                swal({
                    text: "Datos no actualizados",
                    icon: "error",
                    button: "Aceptar",
                });
                this.setState({ modalModTipoTitulacion: false });
            }
        } catch (error) {
            console.error(error);
            this.setState({ error: "No existe conexión con el servidor", modalModTipoTitulacion: false });
            swal({
                text: "No existe conexión con el servidor",
                icon: "error",
                button: "Aceptar",
            });
        }
    };

    // Cambiar estado del tipo de titulación
    bttActDesac = async (tipoTitulacion) => {
        // Alternar estado 1 <-> 0
        const nuevoEstado = Number(tipoTitulacion.estado_tipo_titulacion) === 1 ? 0 : 1;

        try {
            // 1) Actualizar estado
            const response = await axios.post(urlCambiarEstTipoTitulacion, {
                idTipoTitulacion: tipoTitulacion.id_tipo_titulacion,
                estado: nuevoEstado,
            });

            if (response.status === 200 && response.data?.success) {
              
                // 2) Refrescar listado
                const { data } = await axios.get(urlListarTiposTitulacionxCarroTodos, {
                    params: { idCarrera: this.state.idCarrera }
                });

                if (data.success) {
                    const lista = data.data;
                    const itemOffset = 0;
                    const endOffset = itemOffset + itemsPerPage;

                    this.setState({
                        estud: lista,
                        EstudianteBackup: lista,
                        currentItems: lista.slice(itemOffset, endOffset),
                        pageCount: Math.ceil(lista.length / itemsPerPage),
                        itemOffset
                    });
                } else {
                    this.setState({ currentItems: [], error: "No existe información" });
                    swal({
                        text: "¡No existen tipos de titulación registrados!",
                        icon: "info",
                        button: "Aceptar",
                    });
                }
            } else {
                throw new Error(response.data?.message || "No se pudo actualizar el estado.");
            }
        } catch (error) {
            const msg = error.response?.data?.message || "No existe conexión con el servidor";
            swal({ text: msg, icon: "error", button: "Aceptar" });
            console.error("Error en bttActDesac:", error);
        }
    };


    render() {
        return (

            <div className="row animate__animated animate__fadeIn">
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item active">{ }</li>
                </ol>
                <div className="card shadow p-3 mb-5 bg-white rounded">
                    <div className="back-istmas">
                        <i className="fa fa-clipboard-list bounce-custom fs-5"></i>
                        <b className="ms-2">Tipos de titulación</b>
                    </div>
                    <div className="card-body">
                        <div className="row" >
                            <div className="col-12 col-sm-12 col-lg-5 col-xl-5 centrar" >
                                <div className="mb-3">
                                </div>
                            </div>
                        </div>
                        <div className="row ">
                            <div className="col-12 col-sm-12 col-lg-5 col-xl-5 centrar" >
                                <div className="mb-3">
                                    <label className="form-label"><b> <i className="fa-magnifying-glass"></i> Buscar:</b></label>
                                    <input type="text" class="form-control col-md-12" value={this.state.text} placeholder="Buscar..." onChange={(text) => this.filter(text)} />
                                </div>
                            </div>
                            <div className="col-12 col-sm-12  col-lg-5 col-xl-5 centrar" >
                                <div className="mb-3">
                                    <label className="form-label"><b>Carrera</b></label>
                                    <select className="form-select" id="idCarrera" name="idCarrera" value={this.state.value} onChange={this.handleChangeCarrera} aria-label="Default select example">
                                        <option value="undefined" selected="true" disabled>Seleccione una carrera</option>
                                        {this.state.carrera.map(person => <option key={person.id_carrera} value={person.id_carrera} > {person.descripcion_carrera}</option>)}
                                        <option value="todos">Todos</option>
                                    </select>

                                </div>
                            </div>
                        </div>
                        <div className="row ">
                            <div className="col-12 col-sm-12 col-lg-11 col-xl-11 centrar" >
                                <div className="p-3 rounded-3 mt-3">
                                    <h6 className="fw-bold text-center mb-3 text-azul">Tipos de titulación</h6>

                                    <div class="table-responsive">
                                        <table className="table table-hover table-sm-custom">
                                            <thead className="table-light">
                                                <tr className="text-start text-azul">
                                                    <th className="oculto">ID</th>
                                                    <th>Nombre</th>
                                                    <th>Descripción</th>
                                                    <th>Estado</th>
                                                    <th>Modificar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.currentItems &&
                                                    this.state.currentItems.map((consola) => (
                                                        <tr className="text-start text-azul list-afiliados" key={consola.id_tipo_titulacion}>
                                                            <td className="oculto">{consola.id_tipo_titulacion}</td>
                                                            <td>{consola.nom_tipo_titulacion}</td>
                                                            <td>{consola.descrip_tipo_titulacion}</td>
                                                            <td className="text-center">
                                                                {(() => {
                                                                    switch (consola.estado_tipo_titulacion) {
                                                                        case 0:
                                                                            return (
                                                                                <button
                                                                                    className="badge bg-danger text-white px-2 py-1"
                                                                                    style={{ borderRadius: "10px", fontSize: "0.75rem", border: "none" }}
                                                                                    onClick={() => this.bttActDesac(consola)}
                                                                                >
                                                                                    Inactivo
                                                                                </button>
                                                                            );
                                                                        case 1:
                                                                            return (
                                                                                <button
                                                                                    className="badge bg-success text-white px-2 py-1"
                                                                                    style={{ borderRadius: "10px", fontSize: "0.75rem", border: "none" }}
                                                                                    onClick={() => this.bttActDesac(consola)}
                                                                                >
                                                                                    Activo
                                                                                </button>
                                                                            );
                                                                        default:
                                                                            return "";
                                                                    }
                                                                })()}

                                                            </td>
                                                            <td className="text-center">


                                                                <button
                                                                    className="btn btn-link p-0"
                                                                    onClick={() => this.mostrarModalDatosTipoTitulacion(consola)}
                                                                    title="Ver/Editar"
                                                                >
                                                                    <i className="fas fa-pen text-azul bounce-custom"></i>
                                                                </button>

                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>


                                        <Modal isOpen={this.state.modalIngresarTipoTitulacion}>
                                            <ModalHeader>
                                                Ingresar un tipo de titulación
                                            </ModalHeader>
                                            <ModalBody class="colormodal" >
                                                <FormGroup>

                                                    <label className="form-label">Nombre</label>
                                                    <input type="text" id="nombretipo" name="nombretipo" className="form-control" onChange={this.handleChange} required />
                                                    <label className="form-label">Descripción</label>
                                                    <input type="text" id="descriptipo" name="descriptipo" className="form-control" onChange={this.handleChange} required />
                                                    <label className="form-label">Seleccione la carrera a la que pertenece</label>
                                                    <div class="table-responsive">
                                                        <table id="tablacarreras" className="table  text-left" >
                                                            <thead >
                                                                <tr>
                                                                    <th scope="col">Carrera</th>
                                                                    <th scope="col">Seleccionar</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {this.state.carrera.map(consola => (
                                                                    <tr key={consola.id_carrera}>
                                                                        <td class="idCarreraSelect oculto" >{consola.id_carrera}</td>

                                                                        <td class="descriCarreraSelect" >{consola.descripcion_carrera}</td>
                                                                        <td class="selectCarrera">
                                                                            <input disabled={(this.state.disablmodmat) ? "disabled" : ""} name={"checkcarr" + consola.id_carrera} id={"checkcarr" + consola.id_carrera} type="checkbox" class="checkbox-carrtipotituing" />
                                                                            {(() => {
                                                                                $('#checkcarr' + consola.id_carrera).checked = false;
                                                                            })()}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </FormGroup>
                                            </ModalBody>
                                            <ModalFooter>
                                                <Button
                                                    color="primary"
                                                    onClick={() => this.ingresarDatosTipoTitulacion()}
                                                >
                                                    Registrar

                                                </Button>
                                                <Button
                                                    color="secondary"
                                                    onClick={this.ocultarModalIngresarTipoTitul}
                                                >
                                                    Salir
                                                </Button>


                                            </ModalFooter>
                                        </Modal>

                                    </div>

                                    <div className="d-flex justify-content-center mt-4 ">
                                        <ReactPaginate
                                            previousLabel="<"
                                            nextLabel=">"
                                            pageCount={this.state.pageCount}
                                            onPageChange={this.handlePageClick}
                                            containerClassName="pagination pagination-sm-custom"
                                            pageLinkClassName="page-link"
                                            previousClassName="page-item"
                                            previousLinkClassName="page-link"
                                            nextClassName="page-item"
                                            nextLinkClassName="page-link"
                                            activeClassName="active"
                                        />
                                    </div>
                                    <div className="text-center">

                                        <button id="agregar" type="button"
                                            className="btn btn-sm btn-primary fw-semibold px-3 py-1 shadow-sm"
                                            style={{ borderRadius: "8px", fontSize: "0.85rem" }}
                                            onClick={e =>
                                                this.mostrarModalIngresoTiposTitulacion(e)
                                            }
                                        >
                                            <i className="fas fa-plus me-1"></i>Registrar
                                        </button>

                                    </div>


                                </div>
                            </div>
                        </div>
                        <div className="row  ">
                            <div className="mb-3 ">
                                <Modal classname="modal-background" isOpen={this.state.modalModTipoTitulacion}>
                                    <ModalHeader>
                                        <h5></h5>
                                        Modificar los datos del tipo de titulación
                                    </ModalHeader>
                                    <ModalBody>
                                        <FormGroup>

                                            <label className="form-label">Nombre</label>
                                            <input type="text" id="nombretipomod" name="nombretipomod" className="form-control" onChange={this.handleChange} required />
                                            <label className="form-label">Descripción</label>
                                            <input type="text" id="descriptipomod" name="descriptipomod" className="form-control" onChange={this.handleChange} required />
                                            <label className="form-label">Estado</label>
                                            <select className="form-select" id="idestadomod" name="idestadomod" value={this.state.value} onChange={this.handleChange} aria-label="Default select example" disabled={(this.state.disabledformpagmodd) ? "disabled" : ""} >
                                                <option value="0" >Deshabilitado</option>
                                                <option value="1" >Habilitado</option>
                                            </select>
                                            <div className="mb-3">
                                                <label className="form-label">Seleccione el rol</label>
                                                <div class="table-responsive">
                                                    <table id="tablacarrtipomod" className="table  text-left" >
                                                        <thead >
                                                            <tr>
                                                                <th scope="col">Carrera</th>
                                                                <th scope="col">Seleccionar</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.listCarrTipoTitulMod.map(consola => (
                                                                <tr key={consola.id_carrera}>
                                                                    <td class="idCarreraMod oculto">{consola.id_carrera}</td>
                                                                    <td class="decripCarreraMod" >{consola.descripcion_carr}</td>
                                                                    <td class="selectcarreraMod">
                                                                        <input name={"checkmod" + consola.id_carrera} id={"checkmod" + consola.id_carrera} type="checkbox" class="checkbox-carrtipotitumod" />
                                                                        {(() => {

                                                                            if (this.state.modalModTipoTitulacion == true) {
                                                                                if (consola.estado == 1) {
                                                                                    $(function () {
                                                                                        $('#checkmod' + consola.id_carrera)[0].checked = true;
                                                                                    })
                                                                                }
                                                                                else {
                                                                                    if (consola.estado == 0) {
                                                                                        $(function () {
                                                                                            $('#checkmod' + consola.id_carrera)[0].checked = false;
                                                                                        })
                                                                                    }
                                                                                }
                                                                            }
                                                                        })()}

                                                                    </td>
                                                                </tr>
                                                            ))}

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </FormGroup>
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button
                                            color="primary"
                                            onClick={() => this.modificarDatosTipoTitulacion(this.state.form2)}
                                        >
                                            Modificar
                                        </Button>
                                        <Button
                                            color="secondary"
                                            onClick={this.ocultarModalModificartDatosTipoTitulacion}
                                        >
                                            Salir
                                        </Button>

                                    </ModalFooter>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
